import React, { useState } from "react";
import { useNavContext } from "../../context-api/nav-context";
import { links } from "./utils/navLinks";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { subLinks } from "./utils/subLinks";
import MobileLink from "./MobileLink";
/* import logo from "../../Assets/Images/navbar/logoshort.png"; */
const Navbar = () => {
  const { openNavbarMenu } = useNavContext();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const displayNavMenu = (e) => {
    const page = e.target.textContent;
    openNavbarMenu(page);
  };

  const openMobileMenu = () => {
    setIsMobileMenuOpen(true);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="nav-header">
      <nav className="wrapper nav-wrapper">
        <div className="nav-logo">
          <Link to="/">
            <img
              src="https://res.cloudinary.com/duwmjod0j/image/upload/q_80/v1642174751/AquaHeat/Navbar%20Images/logoshort_llwi5s.webp"
              alt="Aqua Heat Pumbing & Heating"
            />
          </Link>
        </div>
        <div className="nav-links">
          <ul>
            {links.map((item) => {
              const { id, url, text } = item;
              return (
                <li key={id}>
                  <Link
                    className="navbar-links"
                    to={url}
                    onMouseOver={displayNavMenu}
                  >
                    {text}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="btn-container">
          <Link to="/boiler-repair" className="btn">
            Repairs
          </Link>
          <Link to="/contact" className="btn btn-sales">
            Contact Sales
          </Link>
        </div>
        <div className="navbar-mobile_hamburger">
          <button
            className="navbar-mobile_hamburger-icon"
            onClick={openMobileMenu}
          >
            <GiHamburgerMenu />
          </button>
        </div>
      </nav>
      <div
        className={
          isMobileMenuOpen ? "navbar-mobile_modal" : "navbar-mobile_hide"
        }
      >
        <div className="navbar-mobile_link-container">
          <div className="mobile-nav-container">
            <img
              src="https://res.cloudinary.com/duwmjod0j/image/upload/q_80/v1642174751/AquaHeat/Navbar%20Images/logoshort_llwi5s.webp"
              alt="AquaHeat Heating & Plumbing"
              className="navbar-mobile_logo"
            />
          </div>
          {subLinks.map((item, index) => {
            const { page } = item;
            return (
              <MobileLink
                key={index}
                links={item.linksOne}
                title={page}
                setIsMobileMenuOpen={setIsMobileMenuOpen}
              />
            );
          })}
        </div>
        <button className="btn-hero btn-quote" onClick={closeMobileMenu}>
          close menu
        </button>
      </div>
    </header>
  );
};

export default Navbar;
